import { InputContentSearch } from '../InputContentSearch/InputContentSearch';
import { InputLightStylePurpleLayout } from '../InputLightStylePurpleLayout/InputLightStylePurpleLayout';
import * as React from 'react';
import { debounce } from 'lodash';
import styled from 'styled-components';
import { nonAccentVietnamese } from '@doltech/utils/lib/text';
import cl from 'classnames';

const Main = styled.div`
  input.input-search {
    min-width: 140px;
  }
`;

interface InputLightStylePurpleSearchBarProps {
  className?: string;
  placeholder?: string;
  defaultValue?: string;
  searchOnEnter?: (searchValue?: string) => void;
  searchOnChange?: (searchValue?: string) => void;
  searchOnBlur?: (searchValue?: string) => void;
  searchOnFocus?: (searchValue?: string) => void;
  onSearchClear?: () => void;
}

export const InputLightStylePurpleSearchBar = (props: InputLightStylePurpleSearchBarProps) => {
  const {
    className,
    searchOnEnter,
    searchOnChange,
    searchOnBlur,
    onSearchClear,
    searchOnFocus,
    placeholder,
    defaultValue,
  } = props;

  const searchOnChangeDebounce = React.useMemo(() => {
    return debounce((newValue) => {
      searchOnChange?.(newValue);
    }, 300);
  }, [searchOnChange]);

  return (
    <Main className={cl('input-light-style-search-bar', className)}>
      <InputLightStylePurpleLayout
        inputContent={
          <InputContentSearch
            defaultValue={defaultValue}
            placeholder={placeholder}
            onEnter={(e) => {
              e.preventDefault();
              searchOnEnter?.(nonAccentVietnamese(e.target.value));
            }}
            onChange={(e) => searchOnChangeDebounce(e.target.value)}
            onBlur={(e) => searchOnBlur?.(e.target.value)}
            onClear={onSearchClear}
            onFocus={(e) => searchOnFocus?.(e.target.value)}
          />
        }
      />
    </Main>
  );
};
